<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedit"><span class="smallcaps">TO</span></p>
<p class="dedi">R<span class="smallcaps">ALPH AND</span> K<span class="smallcaps">AY</span> C<span class="smallcaps">OONEY</span></p>
<p class="dedi"><em class="italic">who know all the answers</em>!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Dedication.vue?9790534c